<template>
  <v-form ref="form" v-model="validForm">
    <v-autocomplete v-model="escenario" @change="change" :items="escenarios" :item-text="getItemText" item-value="id"
      dense filled label="Escenario" return-object :rules="[rules.required]"></v-autocomplete>

  </v-form>
</template>
<script>
import axios from "axios";

export default {
  props: {
    filtroId: { type: Array, default: null },
    filtroEstado: { type: Array, default: null },
    id: { type: Number, default: null },
    generacionId: { type: Number, default: null },
    returnObject: { type: Boolean, default: false }
  },
  data() {
    return {
      escenarios: [],
      escenario: null,
      validForm: false,
      rules: {
        required: (value) => !!value || "Requerido."
      },
    };
  },
  mounted() {

    //this.escenarioId = this.id;
    axios
      .get("/escenario?generacionId=" + this.generacionId)
      .then((response) => {
        console.log(response);
        if (this.filtroId) {
          this.escenarios = response.data.filter((esc) =>
            this.filtroId.includes(esc.id)
          );
        } else if (this.filtroEstado) {
          this.escenarios = response.data.filter((esc) =>
            this.filtroEstado.includes(esc.estado)
          );
        } else {
          this.escenarios = response.data;
        }
        this.escenarios = this.escenarios.filter(esc => this.generacionId.includes(esc.generacion.id));
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    change() {
      this.$emit('setEscenario', this.escenario)
    },
    getItemText(item) {
      return `${item.nombre} - ${item.estado}`;
    }
  }
};
</script>